import { createTheme } from '@mui/material/styles';


const S10Blueblue50 = "#E8F3F7"
const S10Blueblue100 = "#B7DAE6"
const S10Blueblue300 = "#63AFC8"
const S10Blueblue600 = "#147C9D"
const S10Blueblue700 = "#10617B"
const S10Greygrey50 = "#E8E8E8"
const S10Greygrey100 = "#B8B8B8"
const S10Greygrey300 = "#666"
const S10Greygrey400 = "#494949"
const S10Greygrey500 = "#1B1B1B"
const S10Greygrey600 = "#191919"
const S10Greygrey700 = "#131313"
const S10Greygrey900 = "#191919"
const S10Redred500 = "#B50808";
const S10Greengreen50 = "#E8F7F1"
const S10Greengreen100 = "#B7E6D2"
const S10Greengreen500 = "#17AD6F"
const S10Greengreen700 = "#107B4F"

declare module '@mui/material/styles' {
  interface Theme {
    s10palette: {
      S10Blueblue50: string,
      S10Blueblue100: string,
      S10Blueblue300: string,
      S10Blueblue600: string,
      S10Blueblue700: string,
      S10Greygrey50: string,
      S10Greygrey100: string,
      S10Greygrey300: string,
      S10Greygrey400: string,
      S10Greygrey500: string,
      S10Greygrey600: string,
      S10Greygrey700: string,
      S10Greygrey900: string,
      S10Redred500: string,
      S10Greengreen50: string,
      S10Greengreen100: string,
      S10Greengreen500: string,
      S10Greengreen700: string,
    }
  }
  
  interface ThemeOptions {
    s10palette?: {
      S10Blueblue50: string,
      S10Blueblue100: string,
      S10Blueblue300: string,
      S10Blueblue600: string,
      S10Blueblue700: string,
      S10Greygrey50: string,
      S10Greygrey100: string,
      S10Greygrey300: string,
      S10Greygrey400: string,
      S10Greygrey500: string,
      S10Greygrey600: string,
      S10Greygrey700: string,
      S10Greygrey900: string,
      S10Redred500: string,
      S10Greengreen50: string,
      S10Greengreen100: string,
      S10Greengreen500: string,
      S10Greengreen700: string,
    }
  }
}

const theme = createTheme({
  s10palette: {
    S10Blueblue50,
    S10Blueblue100,
    S10Blueblue300,
    S10Blueblue600,
    S10Blueblue700,
    S10Greygrey50,
    S10Greygrey100,
    S10Greygrey300,
    S10Greygrey400,
    S10Greygrey500,
    S10Greygrey600,
    S10Greygrey700,
    S10Redred500,
    S10Greygrey900,
    S10Greengreen50,
    S10Greengreen100,
    S10Greengreen500,
    S10Greengreen700,
  },
  palette: {
    primary: {
      main: S10Blueblue600,
      light: '#81C784',
      dark: '#388E3C',
      contrastText: '#FFFFFF',
    },
  },
  components: {
    MuiFab: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: S10Blueblue700,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: S10Blueblue700,
          },
        },
      },
    },
  },
});

export default theme;